import { render } from "./parent-profession-incremental-field.vue?vue&type=template&id=15e8f98f&scoped=true"
import script from "./parent-profession-incremental-field.vue?vue&type=script&lang=js"
export * from "./parent-profession-incremental-field.vue?vue&type=script&lang=js"

import "./parent-profession-incremental-field.vue?vue&type=style&index=0&id=15e8f98f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e8f98f"]])

export default __exports__